import {SET_ID_DETAILS_REFUND, CLEAR_DETAILS_REFUND_ID} from "./detailsRefundActionTypes"
/**
 * Set the refundId to pop up the component that display the refund details
 * @param {*} id RefundId
 */
export const viewRefundDetails = id => ({
    type: SET_ID_DETAILS_REFUND,
    id,
})

/**
 * Clear the refundId to hide the component that has been displayed
 */
export const clearRefundDetails = () => ({
    type: CLEAR_DETAILS_REFUND_ID,
})
